import { html, render } from 'lit';
import { virtual } from 'haunted';
import { Player as ComponentPlayer } from '@outbook/webcomponents-player';
import { customizeAppPlayer } from '../ui-customize/index.js';

const playerExamples = virtual(() => {
  return html`<div>
    ${customizeAppPlayer({
      component: ComponentPlayer,
      url: '/assets/player/playlist.json'
    })}
  </div>`;
});

export function Player() {
  if (document.getElementById('mythical-player-examples')) {
    render(
      playerExamples(),
      document.getElementById('mythical-player-examples')
    );
  }
}
